import { render, staticRenderFns } from "./AssignedAssetsTable.vue?vue&type=template&id=33ca88f6"
import script from "./AssignedAssetsTable.vue?vue&type=script&lang=js"
export * from "./AssignedAssetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports